import { useTranslation } from 'react-i18next';
import { availableLanguages } from '../i18n';
import DropdownSelector from './DropdownSelector';

const ChangeLanguage = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  return (
    <DropdownSelector
      onChange={changeLanguage}
      label={t("changeLanguage")}
      options={availableLanguages}
      value={i18n.language}
    />
  )
}

export default ChangeLanguage;
